<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'PageFixeEntete'
});
</script>
<template>
  <ka-container
    code="page-fixe-entete"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Container Textes -->
    <ka-container code="container-textes">
      <ka-text code="h-1">
        <h1 v-html="componentInstance.$h1.value" />
      </ka-text>
      <ka-text
        code="text-1"
        :value="componentInstance.$text1.value" />
    </ka-container>
    <!-- Conteneur 1 -->
    <ka-container code="conteneur-1">
      <!-- Conteneur 1 -->
      <ka-container
        code="container-1"
        :options="{ style: { innerImg: componentInstance.$image.value } }" />
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { pageFixeEnteteComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c28')
const component = pageFixeEnteteComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  h1?: Nullable<string>
  text1?: Nullable<string>
  image?: Nullable<string | File>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  h1: 'Ressources pour nos formateurs occasionnels',
  text1: 'Sur cette page vous retrouverez plusieurs ressources pour prendre en mains les outils Matchers et anticiper les différentes étapes d’une formation. Transmettre son savoir c’est avant tout l’organiser !<br> <br><strong>Matchers vous accompagne</strong> dans les démarches administratives relatives à une activité d\'auto-entrepreneur à travers des tutoriels. Pour vous aider à faire de la formation, une nouvelle compétence nous vous partagerons aussi toutes les astuces et les conseils de notre équipe et de notre communauté d’experts.',
  image: 'https://ucarecdn.com/426f0636-f720-43fc-976c-0f87d10d339d/',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:h1',
  'update:text1',
  'update:image'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    h1: true,
    text1: true,
    image: true
  }
})
</script>
